import React, { useEffect, useState } from 'react'
import { Row, Col, DatePicker, Form, Button, Select, Divider, Modal } from 'antd'
import moment from 'moment'
import locale from 'antd/es/date-picker/locale/az_AZ'
import CustomTooltip from 'components/Tooltip'
import SelectField from 'components/SelectField'
import { connect } from 'react-redux'
import { ErrorNotificationIco, BlockAccountIco, ModalCloseIco } from '../../../../../../modules/CustomIcons'
import './index.scss'
import { getAccounts } from '../../../../../services/account';
import { getCurrentCompany } from '../../../../../services/user';
import { getAccountStatementData, setFilterData, setCCYName, setIbanNumber, getSalaryAccountStatement } from '../../../../../store/actions/accountStatement';
import { useActions } from 'hooks/useActions';
import { financial } from '../../../../../services/helper';
import { checkSalaryList } from '../../../../../services/salary'

import InputField from "components/InputField";
import { useTranslation } from 'react-i18next'
import { secureLocalStorageGet } from '../../../../../../app/helpers'
import { getLoggedUserInfo } from '../../../../../services/Auth/GetUserInfo'
import OtpInput from 'react-otp-input'
import Timer from 'components/Timer'

const SalaryPrintFilter: React.FC<any> = (props) => {
  const { t } = useTranslation()
  const { companyData, pagination, ibanNumber } = props;

  const [form] = Form.useForm()
  const dateFormat = 'DD.MM.YYYY'
  const [account, setAccount] = useState('')
  const [isDiffSameOrAfter, setDiff] = useState(true)
  const [datePickerErrorMessage, setDatePickerErrorMessage] = useState('');
  const [startDate, setStartDate] = useState(moment(moment().format(dateFormat), dateFormat))
  const [selectAccountOptions, setAccountOptions] = useState([]);
  const [tranzitacc, setTranzitacc] = useState("")
  const [endDate, setEndDate] = useState(props.endDate)
  const [defeaultEndDate, setDefaultEndDate] = useState(props.businessDate)
  const [accountAllData, setAccountAllData] = useState<Array<any>>([]);
  const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
  let channel = secureLocalStorageGet('channel')
  const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
  const [otpNumberCount, setOtpNumberCount] = useState<number>(5)
  const [otpCode, setOtpCode] = useState<number[]>([])
  const [errorText, setErrorText] = useState('')
  const { getSalaryAccountStatement, setFilterData, setCCYName, setIbanNumber } = useActions();
  const [smsClicked, setClicked] = useState(true)
  const [reset, setReset] = useState<boolean>(false)

  const [loading, setLoading] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const dateFilters = [
    {
      key: 1,
      label: t("transfers.today"),
      dateFrom: moment(moment().format(dateFormat), dateFormat),
      dateTo: moment(props.businessDate, "DD.MM.YYYY"),
    },
    {
      key: 2,
      label: t("transfers.yesterday"),
      dateFrom: moment().add(-1, 'days'),
      dateTo: moment().add(-1, 'days'),
    },
    {
      key: 3,
      label: t("transfers.thisWeek"),
      dateFrom: moment().startOf('week').add(1, 'days'),
      dateTo: moment(props.businessDate, dateFormat),
    },
    {
      key: 4,
      label: t("transfers.lastWeek"),
      dateFrom: moment().subtract(1, 'weeks').startOf('week').add(1, 'days'),
      dateTo: moment().subtract(1, 'weeks').endOf('week').add(1, 'days'),
    },
    {
      key: 5,
      label: t("transfers.thisMonth"),
      dateFrom: moment().startOf('month'),
      dateTo: moment(props.businessDate, dateFormat),
    },
    {
      key: 6,
      label: t("transfers.lastMonth"),
      dateFrom: moment().subtract(1, 'months').startOf('month'),
      dateTo: moment().subtract(1, 'months').endOf('month'),
    },
    {
      key: 7,
      label: t("accountStatement.currentQuarter"),
      dateFrom: moment().startOf('quarter'),
      dateTo: moment(props.businessDate, dateFormat),
    },
    {
      key: 8,
      label: t("accountStatement.previousQuarter"),
      dateFrom: moment().subtract(1, 'quarter').startOf('quarter'),
      dateTo: moment().subtract(1, 'quarter').endOf('quarter'),
    },
    {
      key: 9,
      label: t("accountStatement.thisYear"),
      dateFrom: moment().startOf('year'),
      dateTo: moment(props.businessDate, dateFormat),
    },
    {
      key: 10,
      label: t("accountStatement.1year"),
      dateFrom: moment().subtract(1, 'year'),
      dateTo: moment(props.businessDate, dateFormat),
    },
  ]


  const checkSalary = async () => {
    let accArr: Array<any> = []
    let postData = {
      COMPCIF: getCurrentCompany().customerNo,
      EMPLACC: accArr,
    }

    const data: any = await checkSalaryList(postData)
    setTranzitacc(data?.TRANZITACC)
    props.SetTranzitaccForNotif(data?.TRANZITACC)
  }

  useEffect(() => {
    checkSalary()
  }, [])

  useEffect(() => {
    if (props.businessDate !== null && props.businessDate !== undefined && props.businessDate !== "") {
      setDefaultEndDate(props.businessDate)
      setEndDate(moment(props.businessDate, "DD.MM.YYYY"));
    }
  }, [props.businessDate])

  useEffect(() => {
    setEndDate(props.endDate)
    form.setFieldsValue({ endDate: props.endDate });
  }, [props.endDate])

  const handleAccount = (value: any) => {
    setAccount(value)
  }

  useEffect(() => {
    setAccount(ibanNumber?.iban ?? "")
    setIbanNumber({ iban: undefined })
  }, [])

  const handleStartDate = (date: moment, dateString: string) => {
    // setActiveDateClass(0)
    setStartDate(date)
    if (date) {
      props.handleDateData(0, moment(date), moment(endDate))
    }
  }
  const handleEndDate = (date: moment, dateString: string) => {
    setEndDate(date)
    if (date) {
      props.handleDateData(0, moment(startDate), moment(date))
    }
    // setActiveDateClass(0)
  }

  const handleFilter = (values: any) => {
    props.handleFilter(values)
  }
  useEffect(() => {
    if (!(moment(endDate).isSameOrAfter(startDate))) {
      setDiff(false);
      setDatePickerErrorMessage(t("transfers.startDateCantBeLaterThanEndDate"));
    } else if (!(moment(endDate).isSameOrAfter(moment().subtract(5, 'year'))) || !(moment(startDate).isSameOrAfter(moment().subtract(5, 'year')))) {
      setDiff(false);
      setDatePickerErrorMessage(t("accountStatement.max5years"));
    }
    else if (!(moment(startDate).isSameOrAfter(moment(endDate).subtract(1, 'year')))) {
      setDiff(false);
      setDatePickerErrorMessage(t("accountStatement.maxPeriod"));
    }
    else {
      setDiff(true);
      setDatePickerErrorMessage("");
    }

    // setDiff(isSameOrAfter)
    // setDatePickerErrorMessage(t("transfers.startDateCantBeLaterThanEndDate"));
  }, [startDate, endDate])

  const handleDateFilterData = (key: number, dateFrom: Date, dateTo: Date) => {
    setStartDate(moment(dateFrom))
    setEndDate(moment(dateTo))
    form.setFieldsValue({ startDate: dateFrom, endDate: dateTo })
    props.handleDateData(key, moment(dateFrom), moment(dateTo))
  }


  useEffect(() => {
    const fetchDataAccounts = async () => {
      let accounts = await getAccounts(getCurrentCompany())
      setAccountAllData(accounts)
      let selectAccountOptionsArr: Array<any> = []

      accounts.map((item: any) => {
        return selectAccountOptionsArr.push({

          label:
            <div className="account_filter_select">
              <div className="account_filter_select__number-row">
                <div className="account_filter_select__number-row--text">{item.IBAN}</div>
                {
                  item.STATUS === "0" ?
                    <CustomTooltip
                      title={t("transfers.closedAccount")}
                    >
                      <Button type={'ghost'} className={'transparent'} icon={<BlockAccountIco className='is_red' />} />
                    </CustomTooltip>
                    : <></>
                }

              </div>
              <div className="is_blue">{financial(item.BALANCE) + " " + item.CCY_NAME}</div>
            </div>,
          value: item.IBAN,
        })
      })
      //@ts-ignore
      setAccountOptions(selectAccountOptionsArr)
    }
    fetchDataAccounts()
  }, [])

  const applyFunc = async () => {
    const formData = {
      startDate: startDate,
      endDate: endDate,
      ibanRef: tranzitacc
    }

    const paginationData = {
      pageSize: pagination.pageSize,
      current: pagination.current
    }

    setFilterData([formData, paginationData])
    const limitDate = moment().subtract(180, 'days').startOf('day');

    const isOldDate = moment(startDate, dateFormat).isBefore(limitDate) ||
      moment(endDate, dateFormat).isBefore(limitDate);
   if(false){
      const userData: any = await getLoggedUserInfo()
      let phone_number = userData?.phoneNumber
      let last_4_number = phone_number?.slice(-4)
      let make_phone_number = last_4_number && last_4_number.length >= 4
        ? last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
        : ''
      setPhoneNumber(make_phone_number)
      getSalaryAccountStatement({ company: getCurrentCompany(), formData: formData, paginationData: paginationData });
      setOtpCodeModalVisible(true);
    } else {
      getSalaryAccountStatement({ company: getCurrentCompany(), formData: formData, paginationData: paginationData });
    }
  }

  const handleValue = (value: any) => {
    setOtpCode(value)
    setOtpCodeHasError(false)
    setErrorText('')
  }
  const hideOtpCodeModal = () => {
    setOtpCode([])
    setErrorText('')
    setOtpCodeHasError(false)
    setOtpCodeModalVisible(false)
  }
  const checkOTPCode = async () => {
    setLoading(true)

    try {
     const formData = {
      startDate: startDate,
      endDate: endDate,
      ibanRef: tranzitacc
    }
console.log('isledi')
      setFilterData([formData])
      const data =await getSalaryAccountStatement({ company: getCurrentCompany(), formData: formData, otp: otpCode });
      if (account.length) {
        const ccy_name = accountAllData.filter((item: any) => item.IBAN === account)
        setCCYName({ ccy_name: ccy_name[0].CCY_NAME, iban: ccy_name[0].IBAN, startDate: startDate, endDate: endDate })
      }
      setOtpCodeModalVisible(false)
      setLoading(false)
      setOtpCode([])

    } catch (error) {
      if (error !== null) {
        setOtpCodeHasError(true);
        setLoading(false)

        setErrorText(error?.data?.detail)
      } else {
        setLoading(false)

        console.error("Başqa bir sistem xətası.");
      }
    }


  }
  useEffect(() => {
    if (tranzitacc) {
      setCCYName({ ccy_name: props.currencyType, iban: tranzitacc, startDate: startDate, endDate: endDate })
    }
  }, [getSalaryAccountStatement])


  useEffect(() => {
    applyFunc();
  }, [])

  const changePageSize = (page: number) => {

    const formData = {
      startDate: startDate,
      endDate: endDate,
      ibanRef: account
    }

    const paginationData = {
      current: 1,
      pageSize: page
    }

    getSalaryAccountStatement({ company: getCurrentCompany(), formData: formData, paginationData: paginationData });

    props.setPagination({
      ...pagination,
      pageSize: page,
      current: 1
    })
  }
  const resetFormTimer = () => {
      setOtpCodeModalVisible(false)
  }
const reSend = () => {
    if (smsClicked) {
      setClicked(false)  
    //   setReset(true);
    // setTimeout(() => setReset(false), 1000);
    const formData = {
      startDate: startDate,
      endDate: endDate,
      ibanRef: tranzitacc
    }

    const paginationData = {
      pageSize: pagination.pageSize,
      current: pagination.current
    }

     getSalaryAccountStatement({ company: getCurrentCompany(), formData: formData, paginationData: paginationData });

    }
    // setMinutes(5);
    // setReset(true);
    // setTimeout(() => setReset(false), 1000);
  }
    useEffect(() => {
      if (!smsClicked) {
        let timer1 = setInterval(() => setClicked(true), 20 * 1000)
        return () => { clearInterval(timer1) }
      }
    }, [smsClicked])
  return (
    <>
      <div className="transfers__filter">
        <Form className="fullWidth" form={form} onFinish={handleFilter}>
          <Row justify="start">
            <Row align="top">
              <Col style={{ marginRight: '30px' }}>
                <div className="pickers flex">
                  <label>{t("transfers.period")}</label>
                  <div
                    className="pickers__width flex"
                    style={{ width: '287px', position: 'relative', height: 40 }}
                  >
                    <div>
                      <Form.Item name="startDate">
                        <DatePicker
                          style={{ float: 'left' }}
                          locale={locale}
                          defaultValue={moment(moment(startDate), dateFormat)}
                          className={
                            !isDiffSameOrAfter ? 'errored-ant-picker' : ''
                          }
                          onChange={handleStartDate}
                          suffixIcon={null}
                          value={moment(startDate).format(dateFormat)}
                          format={dateFormat}
                          allowClear={false}
                        />
                      </Form.Item>
                      {!isDiffSameOrAfter && (
                        <CustomTooltip
                          className="error-tooltip"
                          trigger="hover"
                          title={datePickerErrorMessage}
                        // title={t("transfers.startDateCantBeLaterThanEndDate")}
                        >
                          <div className="error-tooltip__icon error-tooltip__icon--left bt-44">
                            <ErrorNotificationIco />
                          </div>
                        </CustomTooltip>
                      )}
                    </div>
                    <span style={{ margin: 'auto 10px' }}>-</span>
                    <div>
                      <Form.Item name="endDate">
                        <DatePicker
                          locale={locale}
                          style={{ float: 'right' }}
                          defaultValue={defeaultEndDate}
                          className={
                            !isDiffSameOrAfter ? 'errored-ant-picker' : ''
                          }
                          onChange={handleEndDate}
                          value={endDate}
                          suffixIcon={null}
                          format={dateFormat}
                          allowClear={false}
                        />
                      </Form.Item>
                      {!isDiffSameOrAfter && (
                        <CustomTooltip
                          className="error-tooltip"
                          trigger="hover"
                          title={datePickerErrorMessage}
                        >
                          <div className="error-tooltip__icon error-tooltip__icon--left bt-44">
                            <ErrorNotificationIco />
                          </div>
                        </CustomTooltip>
                      )}
                    </div>
                  </div>
                </div>
              </Col>

              <Col style={{ display: 'flex', alignItems: 'center', width: '300px' }} className='mobile-select'>
                <InputField
                  name="account"
                  labelItem={t("home.account")}
                  placeholder={t("salary.salaryReport")}
                  options={selectAccountOptions}
                  value={account}
                  onChange={(args: any) => handleAccount(args)}
                  defaultActiveFirstOption={false}
                  dropdownClassName="transfers-dropdown accountStatement-dropdown"
                  optionLabelProp="label"
                  defaultOpen={true}
                  width={500}
                  defaultValue={ibanNumber.iban}
                  page={"accountStatement"}
                  disabled={true}
                />
              </Col>
            </Row>

            <Col
              style={{
                marginLeft: 'auto',
                // display: 'flex',
                // alignItems: 'center',
              }}
            >
              <div className="flex pagination-selector account-pagination-selector">
                <p>{t("salary.numberAtPage")} </p>
                <Select
                  defaultValue={50}
                  dropdownClassName={'hoverable pagination-select'}
                  onChange={changePageSize}
                >
                  {props.pageOptions.map((item) => {
                    return <option value={item}>{item}</option>
                  })}
                </Select>
              </div>
            </Col>
          </Row>
        </Form>
      </div>

      <Row
        className='accountStatement-filter-secondRow'
      >
        <Col>
          <ul className="dates-list flex accountStatement-dates-list">
            {dateFilters.map((item, index) => {
              return (
                <li
                  className={index + 1 == props.activeDateIndex ? 'active' : ''}
                >
                  <p
                    onClick={() =>
                      handleDateFilterData(item.key, item.dateFrom, item.dateTo)
                    }
                  >
                    {item.label}
                  </p>
                </li>
              )
            })}
          </ul>
        </Col>

        <Col>
          <Button htmlType="submit" className="blue-button accountStatement-blue-button" onClick={applyFunc} disabled={tranzitacc !== "" ? false : true}>
            {t("accountStatement.apply")}
          </Button>
        </Col>
      </Row>
      {otpCodeModalVisible && (
        <Modal
          title={
            
              t('transfers.signingBySMSCode')
              
          }
          closeIcon={<ModalCloseIco />}
          centered
          visible={otpCodeModalVisible}
          onOk={hideOtpCodeModal}
          onCancel={hideOtpCodeModal}
          width={422}
          className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          maskClosable={false}
        >
          <div
            className={
              'flex direction_column align_center otp_code_verify_modal_body'
            }
          >
            
              <p>
                {t('settings.otpcode1')}
                {phoneNumber} {t('settings.otpcode2')} <br />
                {t('settings.otpcode3')}
              </p>
            
            <Form
              form={form}
              onSubmit={(e: any) => e.preventDefault()}
              onFinish={checkOTPCode}
              shouldAutoFocus={true}
              autoComplete="off"
              className={
                otpCodeHasError
                  ? 'message-input-form flex direction_column justify_center has_error'
                  : 'flex direction_column justify_center message-input-form'
              }
            >
              <OtpInput
                value={otpCode}
                onChange={handleValue}
                numInputs={otpNumberCount}
                inputStyle="otpInput"
                isInputNum={true}
                shouldAutoFocus={true}
                className="message-input-form__input"
              />

              {otpCodeHasError && (
                <span className={'verify_code_error flex full justify_center'}>
                  {errorText}
                </span>
              )}

              <div className={'full flex direction_column'}>
                <ul
                  className="message-form__details full"
                  style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                >
                  <li className="message-form__time">
                    <Timer timerEnd={resetFormTimer} reset={reset} />
                  </li>
                  <li>
                   
                      <a
                        onClick={reSend}
                        className={smsClicked ? 'active' : 'disabled'}
                      >
                        {t('modal.detailsData')}
                      </a>
                    
                  </li>
                </ul>

                {/*<Button*/}
                {/*  type={'ghost'}*/}
                {/*  className={'transparent resend_verify_code_btn' + smsClicked ? 'active' : 'disabled'}*/}
                {/*  onClick={reSend}*/}
                {/*>*/}
                {/*  SMS kodu yenidən göndər*/}
                {/*</Button>*/}

                <div className="login-form__buttons flex justify_center">
                  <Button
                    size={'large'}
                    className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                    onClick={hideOtpCodeModal}
                  >
                    {t('transfers.back')}
                  </Button>
                  <Button
                    size={'large'}
                    className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                    htmlType="submit"
                  loading={loading}
                  >
                    {t('login.confirm')}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      )}
    </>
  )
}


const mapDispatchToProps = { getSalaryAccountStatement, setFilterData, setCCYName, setIbanNumber }

const mapStateToProps = (state: any) => ({
  companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result.customerNo : getCurrentCompany(),
  ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
})

export default connect(mapStateToProps, mapDispatchToProps)(SalaryPrintFilter)
